import {memo} from 'react';
import styles from './index.module.scss';
import Breadcrumbs from "../../Breadcrumbs";
import RenderContent from "../index";

interface Props {
  innerContent: DynamicObjectType[],
  content: ContentType
}

const NavigationHeader = ({innerContent, content: {url, altText, showBreadcrumbs}}:Props) => {
  return (
    <div className={styles.root}>
      <header className={styles.wrapper}>
        <div className={styles.bg}/>
        <div className={styles.ellipse}/>

        <div className={styles.column}>
          {showBreadcrumbs && <Breadcrumbs/>}
          {innerContent.map((dynamicContent, index) => <RenderContent {...dynamicContent} key={index} />)}
        </div>
        <img src={url} alt={altText} className={styles.image} />
      </header>
    </div>
  )
}

export default memo(NavigationHeader)
